import { render } from "./CustomLeafNodeInLazyMode.vue?vue&type=template&id=708d25fa"
import script from "./CustomLeafNodeInLazyMode.vue?vue&type=script&lang=ts"
export * from "./CustomLeafNodeInLazyMode.vue?vue&type=script&lang=ts"
script.render = render

export default script